'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _useNavMarker = require('./useNavMarker');

var _useNavMarker2 = _interopRequireDefault(_useNavMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavMarkerImpl = function NavMarkerImpl(_ref) {
  var name = _ref.name;

  (0, _useNavMarker2.default)(name);

  return null;
};

if (process.env.NODE_ENV !== 'production') {
  NavMarkerImpl.propTypes = {
    name: _propTypes2.default.string.isRequired
  };
}

var NavMarker = function NavMarker(_ref2) {
  var children = _ref2.children,
      name = _ref2.name,
      _ref2$active = _ref2.active,
      active = _ref2$active === undefined ? true : _ref2$active;
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    children,
    active && _react2.default.createElement(NavMarkerImpl, { name: name })
  );
};

if (process.env.NODE_ENV !== 'production') {
  NavMarker.propTypes = {
    name: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node,
    active: _propTypes2.default.bool
  };
}

exports.default = NavMarker;
module.exports = exports['default'];